import type { ReactNode } from "react";
import { useOrgPermissions } from "@/app/capabilities/api/hooks";
import type { OrgPermission } from "@/app/capabilities/types";

type CanOrgProps = {
  permission: OrgPermission;
  children: ReactNode;
};

/**
 * Render children only if the caller holds the org permission. Use for gating a
 * JSX element (button, card, link). For array filtering or boolean logic, use the
 * `useOrgPermissions().canOrg` hook directly instead.
 */
export function CanOrg({ permission, children }: CanOrgProps) {
  const { canOrg } = useOrgPermissions();

  if (!canOrg(permission)) {
    return null;
  }

  return children;
}
